import Base from './base'
import Request from '@utils/request'

class Dashboard extends Base {
  async index () {
    const url = '/api/dashboard'
    const response = await Request.get(url)

    return response
  }
}

export default new Dashboard()
